export const SITE_URL = "https://bergercontractingllc.com";
export const PHONE = "(701) 314-0177";
export const PHONE_HREF = "tel:+17013140177";
export const EMAIL = "bergercontracting@gmail.com";
export const ADDRESS = "830 S 48th St Shop 10, Grand Forks, ND 58201";
export const HOURS = "Mon–Fri 8am–5pm";
export const SERVICE_AREA =
  "Serving Grand Forks, East Grand Forks and surrounding communities.";
export const GOOGLE_PROFILE = "https://share.google/0iwRLUD4NnVJLOCiT";
export const FACEBOOK = "https://www.facebook.com/bergercontracting/";
